// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RoleService } from '../../services/frontdoor/role.service';
//import { environment } from '../environments/environment'; // if using environments


@Injectable({ providedIn: 'root' })
export class LoginService {
  // Your local PHP API endpoint
 // private apiUrl = 'http://localhost:8000/auth_amh.php';
  private apiUrl = location.hostname === 'localhost'
   // ? 'http://localhost:8000/auth_amh.php'
     ? 'http://localhost:8000/frontDoor/login.php'
    : 'https://PHP-APIV10.allmyhugs.com/frontDoor/login.php';


  // 1) BehaviorSubject that stores if the user is logged in (true) or not (false)
  private _authState = new BehaviorSubject<boolean>(false);

  // 2) Public observable that components can subscribe to
  public authState$ = this._authState.asObservable();




   
  constructor(private http: HttpClient, private roleService: RoleService ) {
    // Optional: On service load, check if there's a valid session cookie
    this.checkAuth().subscribe(isAuth => {
      this._authState.next(isAuth);
    });
  }

  // ============== LOGIN ==============
  login(username: string, password: string, rememberMe: boolean): Observable<any> {
    return this.http.post(
      `${this.apiUrl}?action=login`,
      { username, password, rememberMe },
      { withCredentials: true }
    ).pipe(
      tap((res: any) => {
        if (res?.success) {
          this._authState.next(true);
          // Set the role in the RoleService
          this.roleService.setUserRole(res.role);
        }
      }),
      
      catchError(err => {
        // If error, remain logged out
        this._authState.next(false);
        throw err;
      })
    );
  }

  // ============== LOGOUT ==============
  logout(): Observable<any> {
    return this.http.post(
      `${this.apiUrl}?action=logout`,
      {},
      { withCredentials: true }
    ).pipe(
      tap((res: any) => {
        if (res?.success) {
          this._authState.next(false); // Broadcast "logged out"
        }
      }),
      catchError(err => {
        // On error, also ensure the state is logged out
        this._authState.next(false);
        throw err;
      })
    );
  }

  // ============== CHECK AUTH ==============
  // This calls the server's check-auth endpoint and returns an Observable<boolean>
  checkAuth(): Observable<boolean> {
    interface AuthResponse {
      authenticated: boolean;
    }
    return this.http.get<AuthResponse>(`${this.apiUrl}?action=check-auth`, { withCredentials: true })
      .pipe(
        map(res => res.authenticated === true),
        catchError(() => of(false))
      );
  }

// ============== SIGNUP ==============
signup(signupData: FormData): Observable<any> {
  return this.http.post(`${this.apiUrl}?action=signup`, signupData, { withCredentials: true });
}

  forgot(email: string): Observable<any> {
    return this.http.post(`${this.apiUrl}?action=forgot`, { email }, { withCredentials: false });
  }

  reset(code: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.apiUrl}?action=reset`, { code, newPassword }, { withCredentials: false });
  }

  getProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}?action=profile`, { withCredentials: true });
  }

  extendSession(): Observable<any> {
    return this.http.post(`${this.apiUrl}?action=extend`, {}, { withCredentials: true });
  }
/*
  checkAuth(): Observable<boolean> {
    // Checking if user is authenticated from the server
    interface AuthResponse {
      authenticated: boolean;
    }

    return this.http.get<AuthResponse>(`${this.apiUrl}?action=check-auth`, { withCredentials: true })
      .pipe(
        map((response: AuthResponse) => response.authenticated === true),
        catchError(() => of(false))
      );
  }
      */
}
